<script setup>
import {computed} from "vue";
import SelectInput from "@/Components/SelectInput.vue";
import BooleanInput from "@/Components/BooleanInput.vue";
import InputLabel from "@/Components/InputLabel.vue";
import TextInput from "@/Components/TextInput.vue";

const props = defineProps({
    property: Object,
    modelValue: Number | String | Boolean | Object | null,
    disabled: Boolean,
    error: String | undefined | null,
});
const emit = defineEmits(['update:modelValue']);
const canUseBoolean = computed(() => {
    return props.property.property_values.length === 2
});
const hasLongItemTitle = computed(() => {
    return props.property.type === 'list'
        && props.property.property_values.some(item => item.value.length > 8);
});
const canUseTextInput = computed(() => {
    return props.property.type === 'string'
});

const canUseNumber = computed(() => {
    return props.property.type === 'int'
        || props.property.type === 'float';
})

// console.log('props.hasError', props.hasError)
</script>

<template>
    <div>
        <div v-if="canUseTextInput" class="px-2.5 py-1.25">
            <div class="flex justify-between">
                <InputLabel :class="{'text-red-500': !!error}" :value="property.title"
                            class="font-sans font-medium text-black dark:text-slate-200 flex items-center uppercase"
                />
                <TextInput
                    :disabled="disabled"
                    :has-error="!!error"
                    :modelValue="modelValue"
                    class="w-1/2"
                    @update:modelValue="emit('update:modelValue', $event)"
                />
            </div>
            <div v-if="!!error" class="text-red-500 text-sm mt-1 pl-2">
                <ion-icon name="alert-circle" class="inline-block mr-1 align-middle"></ion-icon>
                <span class="text-sm align-middle">{{ error }}</span>
            </div>
        </div>

        <div v-else-if="canUseNumber" class="px-2.5 py-1.25">
            <div class="flex justify-between gap-2.5">
                <InputLabel :class="{'text-red-500': !!error}" :value="property.title"
                            class="font-sans font-medium text-black dark:text-slate-200 flex items-center uppercase whitespace-nowrap"
                />
                <TextInput
                    :disabled="disabled"
                    :has-error="!!error"
                    :modelValue="modelValue"
                    class="w-1/2"
                    @update:modelValue="emit('update:modelValue', $event)"
                />
            </div>
            <div v-if="!!error" class="text-red-500 text-sm mt-1 pl-2">
                <ion-icon name="alert-circle" class="inline-block mr-1 align-middle"></ion-icon>
                <span class="text-sm align-middle">{{ error }}</span>
            </div>
        </div>

        <div v-else-if="property.type === 'bool'">
            <BooleanInput :disabled="disabled"
                          :modelValue="modelValue"
                          :title="property.title"
                          class="px-2.5 py-1.25"
                          @update:modelValue="emit('update:modelValue', $event)"
                          :has-error="!!error"
            />
            <div v-if="!!error" class="text-red-500 text-sm mt-1 pl-2">
                <ion-icon name="alert-circle" class="inline-block mr-1 align-middle"></ion-icon>
                <span class="text-sm align-middle">{{ error }}</span>
            </div>
        </div>
        <div v-else-if="canUseBoolean && !hasLongItemTitle">
            <BooleanInput :disabled="disabled"
                          :items="property.property_values"
                          :modelValue="modelValue"
                          :title="property.title"
                          title-field="value"
                          class="px-2.5 py-1.25"
                          @update:modelValue="emit('update:modelValue', $event)"
                          :has-error="!!error"
            />
            <div v-if="!!error" class="text-red-500 text-sm mt-1 pl-2">
                <ion-icon name="alert-circle" class="inline-block mr-1 align-middle"></ion-icon>
                <span class="text-sm align-middle">{{ error }}</span>
            </div>
        </div>
        <div v-else>
            <SelectInput :disabled="disabled"
                         :items="property.property_values"
                         :modelValue="modelValue"
                         :title="property.title"
                         title-field="value"
                         width="1/2"
                         class="px-2.5 py-1.25"
                         @update:modelValue="emit('update:modelValue', $event)"
                         :has-error="!!error"
            ></SelectInput>
            <div v-if="!!error" class="text-red-500 text-sm mt-1 pl-2">
                <ion-icon name="alert-circle" class="inline-block mr-1 align-middle"></ion-icon>
                <span class="text-sm align-middle">{{ error }}</span>
            </div>
        </div>
    </div>
</template>
